<template>
  <div
    style="
      width: 100%;
      height: 100%;
      overflow: hidden;
      padding: 20px;
      display: flex;
    "
  >
    <div
      style="
        flex: 1.5;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        row-gap: 10px;
      "
    >
      <div
        style="
          border-radius: 10px;
          box-shadow: 0 0 5px 1px #e2e2e2;
          margin: 3px;
          padding: 20px;
          color: #a2a2a2;
        "
        v-if="state.taxdeclare?.text"
      >
        <ul style="display: flex; align-items: center; column-gap: 5px">
          据报税截止日<strong style="color: #000">{{
            $dayjs(state.taxdeclare.date).format("YYYY年M月D日")
          }}</strong
          >还剩
          <li
            style="
              padding: 5px 10px;
              background-color: #3399ff;
              color: #fff;
              border-radius: 3px;
            "
            v-for="item in state.taxdeclare?.day?.toString()"
            :key="item"
          >
            {{ item }}
          </li>
          <!-- <li
          style="
            padding: 5px 10px;
            background-color: #3399ff;
            color: #fff;
            border-radius: 3px;
          "
        >
          5
        </li> -->
          天，本税期待申报扣缴义务人：{{
            state.taxdeclare?.un_declare_count
          }}，待申报员工发薪批次：{{
            state.taxdeclare?.un_declare_employee_count
          }}。
        </ul>
      </div>
      <div
        style="
          flex: 1;
          display: flex;
          flex-direction: column;
          border-radius: 10px;
          box-shadow: 0 0 5px 1px #e2e2e2;
          margin: 3px;
        "
      >
        <ul
          style="
            border-bottom: 1px solid #e2e2e2;
            font-weight: 600;
            font-size: 13px;
            margin: 0 20px;
            padding: 20px 0;
          "
        >
          待办事项
        </ul>
        <div style="flex: 1; padding: 0 20px 20px 20px; overflow-y: auto">
          <div
            style="
              border-bottom: 1px solid #e2e2e2;
              padding-bottom: 15px;
              padding: 15px;
              cursor: pointer;
            "
            class="notice-ul"
            v-for="item in state.todoData"
            :key="item"
            @click="onNoticeClick(item)"
          >
            <template v-if="item.table_data?.payroll_id">
              <span style="color: #1e90ff">发薪审核</span>
              <ul class="flex align-center" style="margin-top: 5px">
                <li style="font-weight: 600; flex: 1; font-size: 15px">
                  {{ item.table_data?.name }}
                  <text
                    style="color: #a2a2a2; font-weight: 500; margin-left: 3px"
                  >
                    [{{ item.table_data?.payroll_order_id }}]
                  </text>
                </li>
                <li class="flex align-center">
                  <text style="font-size: 14px">实发金额：</text>
                  <c_money
                    :key="item.table_data?.money"
                    :value="item.table_data?.money"
                    :size="20"
                    style="font-weight: bold"
                  />
                </li>
              </ul>
              <ul
                style="
                  font-size: 14px;
                  display: flex;
                  align-items: center;
                  column-gap: 10px;
                  margin-top: 5px;
                "
              >
                <li>
                  <text style="color: #a2a2a2">报税类型：</text>
                  <text>{{ item.table_data?.d_tax_type_name }}</text>
                </li>
                <li style="flex: 1">
                  <text style="color: #a2a2a2">薪资所属期：</text>
                  <text>{{ item.table_data?.month }}</text>
                </li>
                <li>
                  <text style="color: #a2a2a2">员工数量：</text>
                  <text style="font-weight: bold; color: #1e90ff">{{
                    item.table_data?.employee_num
                  }}</text>
                </li>
                <li class="flex align-center">
                  <text style="color: #a2a2a2">个税：</text>
                  <c_money
                    :key="item.table_data?.tax_money"
                    :value="item.table_data?.tax_money"
                    :size="14"
                    style="font-weight: bold; color: #ffa500"
                  />
                </li>
              </ul>
            </template>
            <template v-else>
              <ul style="display: flex; align-items: center">
                <li style="font-size: 15px; font-weight: 600">
                  {{ item.type }}
                </li>
                <li style="margin-left: 10px; color: #a2a2a2; font-size: 13px">
                  {{ item.table_order_id }}
                </li>
              </ul>
              <ul
                style="
                  display: flex;
                  align-items: center;
                  font-size: 15px;
                  margin-top: 5px;
                "
              >
                <li style="flex: 1">{{ item.title }}</li>
                <text style="color: #a2a2a2; font-size: 13px">
                  {{ $dayjs(item.create_time).format("YYYY-MM-DD") }}
                </text>
              </ul>
            </template>
          </div>
          <c_page
            v-if="state.todoTotal > 20"
            :total="state.todoTotal"
            :pageIndex="state.todoParams.page"
            @onLoad="
              (pageIndex) => {
                state.todoParams.page = pageIndex;
                onLoadToDo();
              }
            "
          />
        </div>
      </div>
    </div>
    <div
      style="flex: 1; display: flex; flex-direction: column; margin-left: 20px"
    >
      <div
        style="
          border-radius: 10px;
          box-shadow: 0 0 5px 1px #e2e2e2;
          display: flex;
          padding: 20px;
          cursor: pointer;
        "
        @click="
          $store.commit('openMenu', {
            path: 'HomeEditInfo',
            title: '个人信息',
            refresh: true,
          })
        "
      >
        <div
          style="
            width: 80px;
            height: 80px;
            border-radius: 50%;
            background-color: #3399ff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            color: #fff;
          "
        >
          {{ $store.state.loginUser?.name }}
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-left: 10px;
          "
        >
          <ul style="font-size: 13px; font-weight: 600">
            {{
              $store.state.loginUser?.name + "，早上好"
            }}
          </ul>
          <ul
            v-if="$store.state.loginUser?.department_name"
            style="margin-top: 8px; color: #a2a2a2; font-size: 13px"
          >
            {{
              $store.state.loginUser?.department_name
            }}
          </ul>
        </div>
      </div>
      <div
        style="
          flex: 1;
          border-radius: 10px;
          box-shadow: 0 0 5px 1px #e2e2e2;
          margin-top: 20px;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        "
      >
        <ul
          style="
            border-bottom: 1px solid #e2e2e2;
            font-weight: 600;
            font-size: 13px;
            margin: 0 20px;
            padding: 20px 0;
          "
        >
          通知公告
        </ul>
        <div style="overflow-y: auto; flex: 1; padding: 0 20px 20px 20px">
          <ul
            style="
              display: flex;
              line-height: 70px;
              border-bottom: 1px solid #e2e2e2;
              cursor: pointer;
            "
            class="notice-ul"
            v-for="item in state.noticeData"
            :key="item"
            @click="
              state.noticeModel = item;
              state.showNotice = true;
            "
          >
            <li style="flex: 1; font-weight: 600; font-size: 14px">
              {{ item.title }}
            </li>
            <li style="font-size: 13px; color: #a2a2a2">
              {{ $dayjs(item.create_time).format("YYYY-MM-DD") }}
            </li>
          </ul>
          <c_page
            v-if="state.noticeTotal > 20"
            :total="state.noticeTotal"
            :pageIndex="state.noticeParams.page"
            @onLoad="
              (pageIndex) => {
                state.noticeParams.page = pageIndex;
                onLoadNotice();
              }
            "
          />
        </div>
      </div>
    </div>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showNotice"
      :title="state.noticeModel.title"
      @close="state.showNotice = false"
    >
      <c_AdminNoticeDetail
        @close="state.showNotice = false"
        :id="state.noticeModel.id"
      ></c_AdminNoticeDetail>
    </c_popup>
  </transition>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showDzhb"
      title="到账合并记录详情"
      @close="state.showDzhb = false"
    >
      <c_BankReceivedMergeDetail
        @close="state.showDzhb = false"
        @confirm="
          state.showDzhb = false;
          onLoad();
        "
        :id="state.selectId"
      ></c_BankReceivedMergeDetail>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import { home_todolist, home_noticelist } from "@/http/api";
import { data_gettaxdeclaredatetext } from "@/http/data";
import store from "@/store";
export default {
  setup() {
    const state = reactive({
      todoParams: {
        limit: 0,
        page: 1,
        status: 0,
      },
      noticeParams: {
        limit: 0,
        page: 1,
      },
      taxdeclare: {},
    });
    onMounted(() => {
      onLoadTaxDeclare();
      onLoadToDo();
      onLoadNotice();
    });

    const onLoadToDo = () => {
      home_todolist(state.todoParams).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.todoData = list;
          state.todoTotal = count;
        }
      });
    };

    const onLoadNotice = () => {
      home_noticelist().then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.noticeData = list;
          state.noticeTotal = count;
        }
      });
    };

    const onLoadTaxDeclare = () => {
      data_gettaxdeclaredatetext().then((res) => {
        if (res.status == 200) {
          state.taxdeclare = res.data.data;
        }
      });
    };

    const onNoticeClick = (item) => {
      if (item.type == "发薪审核") {
        //跳转到发薪审核
        store.commit("openMenu", {
          path: "SalaryApplyDetail",
          title: "发薪单审核",
          refresh: true,
          data: {
            id: item.table_id,
          },
        });
      } else if (item.type == "待发薪") {
        //跳转到薪酬发放
        store.commit("openMenu", {
          path: "SalaryPaymentDetail",
          title: "薪资发放单",
          refresh: true,
          data: {
            id: item.table_id,
          },
        });
      } else if (item.type == "到款合并") {
        //跳转到到款合并
        state.selectId = item.table_id;
        state.showDzhb = true;
      }
    };
    return { state, onLoadToDo, onLoadNotice, onLoadTaxDeclare, onNoticeClick };
  },
};
</script>
<style scoped lang="less">
.notice-ul {
  &:hover {
    border-bottom: 2px solid #e2e2e2 !important;
  }
}
</style>
